import Vue from "vue"; //Este import es necesario para el router
import Router from "vue-router"; //Este es el import de router

import Error from "@/views/Error";
import Principal from "@/views/Principal";

Vue.use(Router);

export default new Router({
  //  base: '/e-recibos/',
    mode: "history", //Esto hace que se utilice el history mode de html
    routes: [
        {
            //Produccion
            path: "/e-recibos/",
            //Dev
            //path: "/",
            name: "principal",
            component: Principal
        },
        {
            //Produccion
            path: "/e-recibos/*", //para urls que no existen
            //Dev
            //path: "/*", //para urls que no existen
            name: "error",
            component: Error
        },
        //{ path: '/e-recibos', redirect: '/e-recibos/' },
        //{ path: '/e-recibos/', component: Principal, alias: ['/', '/e-recibos'] }
    ]
});